import { HelpMessage } from 'utils/constants'
import CIMSFormItem from 'components/CIMSFormItem'
import { useCIMSNotificationsPanelContext } from 'components/CIMSNotifications/components/CIMSNotificationsPanelContext'
import RecipientsSelect from 'components/CIMSSelect/common/RecipientsSelect'
import ByRoutingGroupsFormItem from './components/ByRoutingGroupsFormItem'
import { CASNotificationEvent, FrequencyDefault } from '@cims-online/shared'
import CIMSSection from 'components/CIMSSection'
import { InputNumber, TimePicker } from 'antd'

const RenderFormItems: React.FC = () => {
  const { event } = useCIMSNotificationsPanelContext()
  return (
    <>
      {event === CASNotificationEvent.RequestedReview && (
        <CIMSSection
          title={`Requested Review Settings`}
          help={HelpMessage.CAS.Notifications.RequestedReviewSettings}
        >
          <CIMSFormItem
            label="Days Before Review Date"
            name="notificationInterval"
            help={HelpMessage.CAS.Notifications.NotificationThreshold}
            defaultMessage={`${FrequencyDefault.THRESHOLD} days`}
          >
            <InputNumber style={{ width: 135 }} min={0} max={14} />
          </CIMSFormItem>
          <CIMSFormItem
            name="time"
            label="Time of Day"
            help={HelpMessage.CAS.Notifications.Frequency}
            defaultMessage={FrequencyDefault.TIME}
          >
            <TimePicker
              style={{ width: 135 }}
              format={'h:mm a'}
              minuteStep={15}
              showNow={false}
              use12Hours
            />
          </CIMSFormItem>
        </CIMSSection>
      )}
      <CIMSSection
        title={`Every ${event.name} Event`}
        help={HelpMessage.Notifications.Every(
          event,
          'Construction & Admin Submittal'
        )}
      >
        <CIMSFormItem label="Recipients" name="every">
          <RecipientsSelect />
        </CIMSFormItem>
      </CIMSSection>
      {event !== CASNotificationEvent.Submitted && (
        <CIMSSection
          title="Routing Groups"
          help={HelpMessage.CAS.Notifications.ByRoutingGroup(event)}
        >
          <CIMSFormItem name="routingGroups">
            <ByRoutingGroupsFormItem />
          </CIMSFormItem>
        </CIMSSection>
      )}
    </>
  )
}

export default RenderFormItems
